// extracted by mini-css-extract-plugin
module.exports = {"modal-wrapper":"edit-memo-popup_modal-wrapper__2AJHG","modal-body":"edit-memo-popup_modal-body__TkuaM","modal-footer":"edit-memo-popup_modal-footer__2N1B7"};